/* import __COLOCATED_TEMPLATE__ from './date-filter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { type Filter, Operator, type Predicate } from '../steps/filter';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  filter: Filter;
  index: number;
  removeFilter: (index: number) => void;
  setPredicate: (predicate: Predicate, index: number) => void;
}

export default class StandaloneSalesforceSetupArticleSyncFilterItemsDateFilter extends Component<Args> {
  @service declare intl: IntlService;

  @tracked selectedOperator = this.initialSelectedOperator;
  @tracked value = this.initialValue;

  get initialSelectedOperator() {
    if (this.args.filter.predicate.operator === undefined) {
      return Operator.Equal;
    }

    return this.args.filter.predicate.operator;
  }

  get initialValue() {
    if (this.args.filter.predicate.value === undefined) {
      return new Date();
    }

    return this.parseToDate(this.args.filter.predicate.value as string);
  }

  get dateString() {
    return this.value.toISOString().split('T')[0];
  }

  get predicate() {
    return {
      ...this.args.filter.predicate,
      operator: this.selectedOperator,
      value: this.value.toISOString(),
    };
  }

  get radioButtons() {
    return [
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.filter-items.date-filter.on',
        ),
        value: Operator.Equal,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.filter-items.date-filter.before',
        ),
        value: Operator.LessThan,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.filter-items.date-filter.after',
        ),
        value: Operator.GreaterThan,
      },
    ];
  }

  get filterBlockDetails() {
    let operatorLabel = this.radioButtons.find(
      (item) => item.value === this.selectedOperator,
    )?.label;

    return `${operatorLabel} ${this.dateString}`;
  }

  @action
  onSelectDate(selectedDate: { date: Date }) {
    this.value = selectedDate.date;
  }

  @action
  onClose() {
    this.args.setPredicate(this.predicate, this.args.index);
  }

  private parseToDate(value: string) {
    let parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return new Date();
    }

    return parsed;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::FilterItems::DateFilter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsDateFilter;
    'standalone/salesforce/setup/article-sync/filter-items/date-filter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsDateFilter;
  }
}
